import React from 'react'

import HintForPremiumComponent from 'components/product/HintForPremium/HintForPremium'

import s from './HintForPremium.scss'
import messages from '../messages'


const HintForPremium = () => (
  <HintForPremiumComponent
    className={s.container}
    buttonTitle={messages.hintForPremiumTitle}
    placement="skincare product details modal"
  />
)


export default HintForPremium
